import {
  buildUrlFromBase,
  eolsBaseApi,
  withApiErrorLoggingOnly
} from '../../utilities/api.utilities';
import { AuthessHealthResponse } from './eaq-app-facade-service.dtos';
import { InitiateAssessment, NextRedirectPayload } from '../eols-app-link/eols-app-link.dtos';

export const fetchAuthessHealthCheck = (courseSectionId: string): Promise<AuthessHealthResponse> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get<AuthessHealthResponse>(
      `/eaq/authess/courseSection/${courseSectionId}/healthcheck`
    );
  });
};

// * - Assessment Player API for app link
export const initiateAssessmentApi = (): string =>
  buildUrlFromBase('/eaq/assessment/config');

// * - Payload for Assessment Player API app link setup
export const initiateAssessmentPayloadForEAQ = (assignmentId: number, assessmentId: number = null): InitiateAssessment => {
  return {
    url: initiateAssessmentApi(),
    httpMethod: 'POST',
    payload: {
      assignmentId,
      assessmentId
    }
  };
};

// * - Tells Assessment Player to app link to Student Study on completion instead of Courseware
export const nextRedirectPayloadForEAQ: NextRedirectPayload = {
  COMPLETED: {
    action: 'ASSESSMENT_PERFORMANCE_VIEW',
    target: 'STUDENT_STUDY'
  }
};

// * - New Relic/Pendo data for Assessment Player app link
export const integrationMetadataForEAQ = {
  name: 'EAQ'
};
